import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BackButton, Container } from '../../../../../Components';
import { Panel } from '../../../../../Components/Panel/Panel';
import { ImpersonationRequestForm } from './ImpersonationRequestForm';

export const CreateImpersonationRequest = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <BackButton link="/admin/law-portal/support-invites" />
      <Panel titleKey="admin.impersonation-request.title" accordion={false}>
        <ImpersonationRequestForm onSent={() => navigate('/admin/law-portal/support-invites')} />
      </Panel>
    </Container>
  );
};
